class ProjectorPowerFlbck {
	allowPlayAnyway = $state(false)
}

export const ProjectorPowerFallback = new ProjectorPowerFlbck()
